function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export function products() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    product: {
      model: null,
      fetching: false,
      fetched: false
    },
    productPage: {
      fetching: false,
      fetched: false
    },
    pages: {
      fetching: false,
      fetched: false,
      items: []
    },
    products: {},
    storeFrontArticles: [],
    storeFrontQuestions: [],
    organizations: {
      managers: [],
      distributors: []
    },
    storeFrontVideos: {
      items: []
    },
    productRequest: {
      product: null,
      commercialRelationship: null,
      tag: null
    },
    storefronts: [],
    generics: []
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'SET_PRODUCT_FETCHING_STATUS':
      {
        return _objectSpread(_objectSpread({}, state), {
          product: _objectSpread(_objectSpread({}, state.product), {
            fetching: action.fetching,
            fetched: action.fetched
          })
        });
      }
    case 'SET_PRODUCT':
      {
        const newState = _objectSpread({}, state);
        newState.product = {
          model: action.product,
          fetching: false,
          fetched: true
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLEAR_PRODUCT':
      {
        const newState = _objectSpread({}, state);
        newState.product = {};
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_PRODUCT_PAGES':
      {
        const newState = _objectSpread({}, state);
        newState.pages = {
          fetching: false,
          fetched: true,
          items: action.pages
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_PRODUCT_PAGE':
      {
        const newState = _objectSpread({}, state);
        newState.productPage = _objectSpread(_objectSpread({}, action.page), {}, {
          fetching: false,
          fetched: true
        });
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_PRODUCT_PAGE_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        newState.productPage = {
          fetching: action.fetching,
          fetched: action.fetched
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'CLEAR_PRODUCT_PAGE':
      {
        const newState = _objectSpread({}, state);
        newState.productPage = {
          fetching: false,
          fetched: false
        };
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_PRODUCTS_FETCHING_STATUS':
      {
        const newState = _objectSpread({}, state);
        if (!newState.products[action.id]) {
          newState.products[action.id] = {
            page: 1,
            items: [],
            paging: {},
            request: {},
            fetching: false,
            fetched: false
          };
        }
        const data = _objectSpread({}, newState.products[action.id]);
        data.fetching = action.fetching;
        data.fetched = action.fetched;
        const newObject = {
          [action.id]: data
        };
        newState.products = _objectSpread(_objectSpread({}, newState.products), newObject);
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_PRODUCTS':
      {
        const newState = _objectSpread({}, state);
        if (!newState.products[action.id]) {
          newState.products[action.id] = {
            page: 1,
            items: [],
            paging: {},
            request: {},
            fetching: false,
            fetched: false
          };
        }
        const data = _objectSpread({}, newState.products[action.id]);
        data.items = [...data.items, ...action.items];
        data.paging = action.paging;
        data.fetching = false;
        data.fetched = true;
        const newObject = {
          [action.id]: data
        };
        newState.products = _objectSpread(_objectSpread({}, newState.products), newObject);
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_STOREFRONT_ARTICLES':
      {
        const newState = _objectSpread({}, state);
        newState.storeFrontArticles = [...action.articles];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_STOREFRONT_QUESTIONS':
      {
        const newState = _objectSpread({}, state);
        newState.storeFrontQuestions = action.questions;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_ORGANIZATIONS':
      {
        const newState = _objectSpread({}, state);
        newState.organizations[action.organizationsType] = action.organizations;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_STOREFRONT_VIDEOS':
      {
        const newState = _objectSpread({}, state);
        newState.storeFrontVideos.items = action.videos;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_PRODUCT_REQUEST':
      {
        const newState = _objectSpread({}, state);
        newState.productRequest = action.params;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_STOREFRONTS':
      {
        const newState = _objectSpread({}, state);
        newState.storefronts = action.storefronts;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'SET_GENERIC_PRODUCTS':
      {
        const newState = _objectSpread({}, state);
        newState.generics = action.products;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    default:
      return state;
  }
}